<template>
  <div>
    <div class="timeSearch">
      <label for="">时间范围</label>
      <RangePicker
        :disabled-date="disabledDate"
        :disabled-time="disabledRangeTime"
        :show-time="{ format: 'HH:mm' }"
        separator="→"
        format="YYYY-MM-DD HH:mm"
        :placeholder="['开始时间', '结束时间']"
        @change="onChange"
        @openChange="isOpen"
        :getCalendarContainer="getCalendarContainer()"
      >
        <Icon slot="suffixIcon" type="calendar" />
      </RangePicker>
      <span v-show="isErrorTime" class="errorTime">不能选择未来时间</span>
    </div>
    <div class="bar">
      <div class="dosage">
        <div>
          <label> 统计量 </label>
          <Select
            v-model="fieldIndex"
            style="width: 150px"
            @change="changeTotal"
            :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}"
          >
            <Option value="1">新开License数量</Option>
            <Option value="2">新增客户数量</Option>
            <Option value="3">申请License人数</Option>
          </Select>
        </div>
        <div>
          <label>维度</label>
          <Select v-model="dimIndex" @change="changeDim"   :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}">
            <Option value="1">时间</Option>
            <Option value="2">产品</Option>
            <Option value="3">区域</Option>
          </Select>
        </div>
        <div v-show="isPar">
          <label>粒度</label>
          <Select v-model="granIndex" @change="changePart"   :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}">
            <Option :disabled="isAllow" value="1">按日</Option>
            <Option :disabled="isAllowMon" value="2">按月</Option>
            <Option value="3">按年</Option>
          </Select>
        </div>
      </div>
      <div class="chart_div boeder">
        <v-chart ref="licenseTrend" :options="licenseTrend.option" :nodata='licenseTrend.nodata'></v-chart>
      </div>
    </div>
    <div class="pie">
      <div class="filter">
        <span>按</span>
        <Select
          v-model="sepiaFilter"
          class="filter-select"
          @change="changeSpeia"
            :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}"
        >
          <Option
            v-for="item in searchList"
            :key="item.index"
            :value="item.index"
            >{{ item.value }}</Option
          >
        </Select>
        <i class="icon-add" v-show="!isAdd" @click="isAdd = true"></i>
        <i class="icon-reduce" v-show="isAdd" @click="changeValue(1)"></i>
        <Select
          v-show="isAdd"
          v-model="addFilter"
          class="filter-select"
          @change="changeSecond"
            :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}"
        >
          <Option
            v-for="item in searchAdd"
            :key="item.index"
            :value="item.index"
            >{{ item.value }}</Option
          >
        </Select>
        <i class="icon-reduce" v-show="isAdd" @click="changeValue(2)"></i>
        <span class="end">查看产品License量</span>
      </div>
      <div class="chart_div">
        <v-chart ref="licensePie" :options="licensePie.option" :nodata='licensePie.nodata'></v-chart>
      </div>
      <div class="progress">
        <Spin :indicator="indicator" :spinning="loading">
          <!-- <PieList :pieList="pieList" :num="num"></PieList> -->
          <PieList :pieList="pieList"></PieList>
        </Spin>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Select,
  Tooltip,
  Progress,
  Icon,
  DatePicker,
  Spin,
} from 'ant-design-vue'
const { Option } = Select
const { RangePicker } = DatePicker
import { bar, pie, getTootipFormatter } from '@/components/chart/defaultOption'
import VChart from '@/components/chart/Chart'
import moment from 'moment'
import { merge, isEmpty } from 'lodash'
import {
  LICENSE_SERIES,
  INDICATORS,
  makeData,
  innerData,
} from './chart/chartOption'
import PieList from './list'
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapActions } = createNamespacedHelpers('statis')

export default {
  name: 'Statistics',
  data() {
    return {
      indicator: <Icon type="loading" style="font-size: 24px" spin />,
      pageTime: null,
      startTime: null,
      endTime: null,
      isErrorTime: false,
      fieldIndex: '1',
      dimIndex: '1',
      granIndex: '1',
      isAllow: false,
      isAllowMon: false,
      licenseTrend: {
        option: {},
        nodata: false,
      },
      sepiaFilter: '1',
      addFilter: '',
      list: [
        { index: '1', value: 'License状态' },
        { index: '2', value: '阶段' },
        // { index: '3', value: '购买模式' },
        { index: '4', value: '有效期剩余' },
        { index: '5', value: 'License类型' },
      ],
      pieList: [],
      // num: 0,
      isAdd: false,
      licensePie: {
        option: {},
        nodata: false,
      },
      loading: false,
    }
  },
  computed: {
    ...mapState(['licenses']),
    isDay() {
      return moment(this.endTime).diff(moment(this.startTime), 'day')
    },
    isMon() {
      return moment(this.endTime).diff(moment(this.startTime), 'month')
    },
    isPar() {
      return this.dimIndex === '1'
    },
    searchAdd() {
      return this.list.filter((item) => item.index != this.sepiaFilter)
    },
    searchList() {
      return this.list.filter((item) => item.index != this.addFilter)
    },
  },
  watch: {
    isDay(val) {
      if (val > 90) {
        this.isAllow = true
        this.granIndex = '2'
      } else {
        this.isAllow = false
        this.granIndex = '1'
      }
    },
    isMon(val) {
      if (val > 90) {
        this.isAllow = true
        this.isAllowMon = true
        this.granIndex = '3'
      } else if (this.isDay > 90) {
        this.isAllow = true
        this.granIndex = '2'
      } else {
        this.isAllow = false
        this.isAllowMon = false
        this.granIndex = '1'
      }
    },
  },
  mounted() {
    // this.getBar()
    this.pageTime = moment().format('YYYY-MM-DD HH:MM')
    this.renderLicenseTrend()
    this.renderLicensePie()
    this.renderList()
  },
  methods: {
    ...mapActions(['getBar', 'getPieList', 'getPie']),
    getCalendarContainer() {
      return (triggerNode) => triggerNode.parentNode
    },
    range(start, end) {
      const result = []
      for (let i = start; i < end; i++) {
        result.push(i)
      }
      return result
    },
    disabledDate(current) {
      return current >= moment().endOf('day')
    },
    disabledRangeTime(_, type) {
      let start = moment().calendar().substring(2).split(':')
      let end = moment().diff(moment(this.endTime), 'days')
      let endHours = moment().diff(moment(this.endTime), 'hours')
      let st = moment().diff(
        moment(this.startTime).format('YYYY-MM-DD'),
        'days'
      )
      let stHours = moment().diff(
        moment(this.startTime).format('YYYY-MM-DD HH'),
        'hours'
      )
      if (type === 'end') {
        if (end <= 0 && endHours <= 0) {
          return {
            disabledHours: () =>
              this.range(0, 24).splice(
                Number(start[0]) + 1,
                Number(24 - start[0])
              ),
            disabledMinutes: () =>
              this.range(0, 60).splice(
                Number(start[1]) + 1,
                Number(60 - start[1])
              ),
          }
        } else if (end <= 0) {
          return {
            disabledHours: () =>
              this.range(0, 24).splice(
                Number(start[0]) + 1,
                Number(24 - start[0])
              ),
          }
        } else {
          return {}
        }
      }
      if (type === 'start') {
        if (stHours <= 0) {
          return {
            disabledHours: () =>
              this.range(0, 24).splice(
                Number(start[0]) + 1,
                Number(24 - start[0])
              ),
            disabledMinutes: () =>
              this.range(0, 60).splice(
                Number(start[1]) + 1,
                Number(60 - start[1])
              ),
          }
        } else if (st <= 0) {
          return {
            disabledHours: () =>
              this.range(0, 24).splice(
                Number(start[0]) + 1,
                Number(24 - start[0])
              ),
          }
        } else {
          return {}
        }
      }
    },
    onChange(value, dateString) {
      this.startTime = dateString[0]
      this.endTime = dateString[1]
      if (value.length === 0) {
        this.renderLicenseTrend()
        this.renderLicensePie()
        this.renderList()
      }
    },
    onOk(value) {
      this.isErrorTime = false
      if (
        moment(this.endTime).format('YYYY-MM-DD hh:mm').valueOf() >
        moment(this.pageTime).valueOf()
      ) {
        this.isErrorTime = true
        // 不能选择未来时间
      } else {
        this.renderLicenseTrend()
        this.renderLicensePie()
        this.renderList()
      }
    },
    isOpen(val) {
      if (!val) {
        this.onOk(this.startTime)
      }
    },
    changeTotal(val) {
      this.fieldIndex = val
      this.renderLicenseTrend()
    },
    changeDim(val) {
      
      this.dimIndex = val
      this.renderLicenseTrend()
    },
    changePart(val) {
      this.granIndex = val
      this.renderLicenseTrend()
    },
    changeValue(val) {
      if (val === 1) {
        if (this.addFilter === '') return
        this.sepiaFilter = this.addFilter
      }
      this.addFilter = ''
      this.isAdd = false
      this.renderLicensePie()
      this.renderList()
    },
    changeSpeia(val) {
      this.sepiaFilter = val
      this.renderLicensePie()
      this.renderList()
    },
    changeSecond(val) {
      this.addFilter = val
      this.renderLicensePie()
      this.renderList()
    },
    // 柱状图
    async renderLicenseTrend() {
      this.$refs.licenseTrend && this.$refs.licenseTrend.showLoading()
      let params = {
        dimIndex: Number(this.dimIndex),
        fieldIndex: Number(this.fieldIndex),
        granIndex: Number(this.granIndex),
        startTime: this.startTime,
        endTime: this.endTime,
      }
      let res = await this.getBar(params)

    res.forEach((item)=>{
      console.log('%c 🥕 item: ', 'font-size:20px;background-color: #93C0A4;color:#fff;', item);
      if(this.dimIndex !== '2' && item.hasOwnProperty('district') !=true){
        item['district']='其他'
      }
      if (this.dimIndex == '2' && item.hasOwnProperty('type') !=true) {
        item['type'] = '其他'
      }
      return item
    })
      console.log('%c 🍢 res: ', 'font-size:20px;background-color: #ED9EC7;color:#fff;', res);
      this.$refs.licenseTrend && this.$refs.licenseTrend.hideLoading()
      this.licenseTrend.nodata = false
      if (res?.length>0) {
        if (res.length > 90) {
          res = res.slice(0, 90)
        }
        let opt = {}
        opt.dataset = {
          source: res,
        }
        opt.tooltip = {
          formatter: getTootipFormatter(INDICATORS[this.fieldIndex]),
        }
        this.licenseTrend.option = merge(
          {},
          bar.basic,
          {
            series: LICENSE_SERIES(this.dimIndex, this.fieldIndex)[
              'licensesTrend'
            ],
          },
          opt
        )
        if(res.length > 12){
          this.licenseTrend.option.xAxis.show=false
        }
      } else {
        this.licenseTrend.nodata = true
        // this.licenseTrend.option = merge({}, bar.noData)
        // this.licenseTrend.option.series[0].data = [
        //   [this.startTime, 0],
        //   [this.endTime, null],
        // ]
      }
    },
    // 饼图
    async renderLicensePie() {
      this.$refs.licensePie && this.$refs.licensePie.showLoading()
      let params = {
        inIndex: Number(this.sepiaFilter),
        startTime: this.startTime,
        endTime: this.endTime,
        // outIndex:Number(this.addFilter)
      }
      if (this.addFilter) params.outIndex = Number(this.addFilter)
      let res = await this.getPie(params)
      this.$refs.licensePie && this.$refs.licensePie.hideLoading()
      this.licensePie.nodata = false
      if (res?.length>0) {
        let typeData = innerData(res, 'inLabel', 'inVal') //name,value,百分比,类型
        let bransData = [] // 外环图数据
        if (this.addFilter !== '') {
          bransData = innerData(res, 'outLabel', 'outVal') //name,value,百分比,类型
        }
        this.licensePie.option = makeData(
          typeData,
          this.sepiaFilter,
          bransData,
          this.addFilter
        )
      } else {
        // this.licensePie.option = pie.noData
        this.licensePie.nodata = true
      }
    },
    //列表
    async renderList() {
      this.loading = true
      let params = {
        inIndex: Number(this.sepiaFilter),
        startTime: this.startTime,
        endTime: this.endTime,
        // outIndex:Number(this.addFilter)
      }
      if (this.addFilter) params.outIndex = Number(this.addFilter)
      // this.num = 0
      let res = await this.getPieList(params)

      if (res) {
        this.loading = false
        this.pieList = res
        // let arr = res.map((item) => item.total)
        // for (let i = 0; i < arr.length; i++) {
        //   this.num += arr[i]
        // }
      }
    },
  },
  components: {
    Select,
    Option,
    VChart,
    Tooltip,
    Progress,
    Icon,
    RangePicker,
    PieList,
    Spin,
  },
}
</script>
